import { BusinessRegistrationService } from '../../../_services/BusinessRegistration.Service';
import { resolveApiErrorMessage } from '../../../_helpers/apiResponse';
import { getBrSubmissionApprovalId } from '../utils/brDocument';

/**
 * Set as Current 弹窗状态与提交流程（供应商 / 管理端共用）。
 * 差异通过可覆盖方法注入：
 * - buildSetAsCurrentPayload(approvalId)
 * - afterSetAsCurrentSuccess({ nameEn, nameZh, data })
 * - onSetAsCurrentInvalidOpen()
 */
export default {
  data() {
    return {
      showSetAsCurrentModal: false,
      setAsCurrentApprovalId: null,
      setAsCurrentSubmitting: false,
      showSetAsCurrentSuccess: false,
    };
  },
  methods: {
    buildSetAsCurrentPayload(approvalId) {
      return { approvalId };
    },
    async afterSetAsCurrentSuccess() {
      // 由页面覆盖：刷新列表 / 同步展台名 / 清缓存
    },
    onSetAsCurrentInvalidOpen() {
      // 管理端可 toast；供应商静默
    },
    openSetAsCurrentModal(item) {
      const approvalId = Number(getBrSubmissionApprovalId(item));
      if (!Number.isFinite(approvalId) || approvalId <= 0) {
        this.onSetAsCurrentInvalidOpen();
        return;
      }
      this.setAsCurrentApprovalId = approvalId;
      this.showSetAsCurrentModal = true;
    },
    closeSetAsCurrentModal() {
      if (this.setAsCurrentSubmitting) {
        return;
      }
      this.showSetAsCurrentModal = false;
      this.setAsCurrentApprovalId = null;
    },
    async confirmSetAsCurrent() {
      const approvalId = Number(this.setAsCurrentApprovalId);
      if (!Number.isFinite(approvalId) || approvalId <= 0 || this.setAsCurrentSubmitting) {
        return;
      }
      const payload = this.buildSetAsCurrentPayload(approvalId);
      if (!payload) {
        this.onSetAsCurrentInvalidOpen();
        return;
      }
      this.setAsCurrentSubmitting = true;
      try {
        const res = await BusinessRegistrationService.SetAsCurrent(payload);
        if (!res?.isSuccessful) {
          throw new Error(resolveApiErrorMessage(res) || this.$t('lbl_EMPBE_BR_SetAsCurrent_Failed'));
        }
        const data = res?.data || {};
        const nameEn = String(data.displayNameEn ?? data.DisplayNameEn ?? '').trim();
        const nameZh = String(data.displayNameZh ?? data.DisplayNameZh ?? '').trim();
        this.showSetAsCurrentModal = false;
        this.setAsCurrentApprovalId = null;
        await this.afterSetAsCurrentSuccess({ nameEn, nameZh, data });
        this.showSetAsCurrentSuccess = true;
      } catch (e) {
        this.$toast?.error?.(e?.message || this.$t('lbl_EMPBE_BR_SetAsCurrent_Failed'));
      } finally {
        this.setAsCurrentSubmitting = false;
      }
    },
  },
};
